import { Box } from "@bcc-ui/ui-components";
import * as React from "react";

import style from "components/ai-panel/ai-panel.scss";
import { ResolvedProduct } from "components/ai-panel/productTagUtils";
import { Products } from "components/ai-panel/useFilteredProducts";
import ProductCard from "components/products/product-card/ProductCard";
import { OnboardingState } from "domain/onboardings";
import { SoftwarePackage } from "domain/softwarePackages";

const renderProductCard = (
    name: string,
    softwarePackages: SoftwarePackage[],
    products: Products,
    onOnboardingStateChange: (updater: (prev: OnboardingState) => OnboardingState) => void
) => (
    <Box key={name} className={style.aiProductCardWrapper} columnLayout marginBottom="Sm" marginTop="Sm">
        <ProductCard
            name={name}
            additionalProduct={softwarePackages[0]?.bmpHomeCategory === "additional"}
            softwarePackages={softwarePackages}
            fetchedSoftwarePackages={products.softwarePackages}
            fetchedLicenses={products.licenses}
            bdeOnboarded={products.onboardingState.bdeOnboarded}
            bmdeOnboarded={products.onboardingState.bmdeOnboarded}
            bmpOpOnboarded={products.onboardingState.bmpOpOnboarded}
            barOnboarded={products.onboardingState.barOnboarded}
            bmweOnboarded={products.onboardingState.bmweOnboarded}
            saveBdeOnboarded={(onboarded) => onOnboardingStateChange((prev) => ({ ...prev, bdeOnboarded: onboarded }))}
            saveBmdeOnboarded={(onboarded) =>
                onOnboardingStateChange((prev) => ({ ...prev, bmdeOnboarded: onboarded }))
            }
            saveBmpOpOnboarded={(onboarded) =>
                onOnboardingStateChange((prev) => ({ ...prev, bmpOpOnboarded: onboarded }))
            }
            saveBarOnboarded={(onboarded) => onOnboardingStateChange((prev) => ({ ...prev, barOnboarded: onboarded }))}
            saveBmweOnboarded={(onboarded) =>
                onOnboardingStateChange((prev) => ({ ...prev, bmweOnboarded: onboarded }))
            }
            lastCompletedBdeStep={products.onboardingState.lastCompletedBdeStep}
            lastCompletedBmdeStep={products.onboardingState.lastCompletedBmdeStep}
            lastCompletedBmpOpStep={products.onboardingState.lastCompletedBmpOpStep}
            lastCompletedBarStep={products.onboardingState.lastCompletedBarStep}
            lastCompletedBmweStep={products.onboardingState.lastCompletedBmweStep}
            saveLastCompletedBdeStep={(step) =>
                onOnboardingStateChange((prev) => ({ ...prev, lastCompletedBdeStep: step }))
            }
            saveLastCompletedBmdeStep={(step) =>
                onOnboardingStateChange((prev) => ({ ...prev, lastCompletedBmdeStep: step }))
            }
            saveLastCompletedBmpOpStep={(step) =>
                onOnboardingStateChange((prev) => ({ ...prev, lastCompletedBmpOpStep: step }))
            }
            saveLastCompletedBarStep={(step) =>
                onOnboardingStateChange((prev) => ({ ...prev, lastCompletedBarStep: step }))
            }
            saveLastCompletedBmweStep={(step) =>
                onOnboardingStateChange((prev) => ({ ...prev, lastCompletedBmweStep: step }))
            }
            halfSizedCard={false}
            fetchedOnboardingImages={products.onboardingImages}
            aiPanelCard
        />
    </Box>
);

export const renderResolvedProductCard = (
    productId: string,
    resolved: ResolvedProduct,
    products: Products,
    onOnboardingStateChange: (updater: (prev: OnboardingState) => OnboardingState) => void
) => {
    if (!resolved) {
        return null;
    }

    return (
        <React.Fragment key={productId}>
            {Object.entries(resolved).map(([name, softwarePackages]) =>
                renderProductCard(name, softwarePackages, products, onOnboardingStateChange)
            )}
        </React.Fragment>
    );
};
